import React from 'react';
import {IUserModel} from '@src/@interfaces/models/User/IUserModel';
import {MakeRequired} from '@src/@types/RequireOne';
import classnames from '@src/helpers/classnames';
import avatarPlaceholder from '@client/assets/images/avatar-placeholder.gif';

export function getUserName(user: Partial<IUserModel> | undefined | null): string | null;
export function getUserName(user: Partial<IUserModel> | undefined | null, withDefaultReplacement: true): string;
export function getUserName(user?: Partial<IUserModel> | null, withDefaultReplacement = false): string | null {
    const name = user?.full_name ?? user?.name;
    if (name == null && !withDefaultReplacement) {
        return name ?? null;
    }

    return name ?? `User #${user?.id ?? 'unknown'}`;
}

export default function InlineUserRepresentation(props: {
    user?: MakeRequired<Partial<IUserModel>, 'id' | 'avatar_public_path' | 'name'> | null
    tag?: 'span' | 'div',
    className?: string | undefined,
    children?: React.ReactNode,
    avatarWrapperClassName?: string,
    avatarSize?: number,
    title?: string,
}) {
    const {user, title, tag: Wrapper = 'span', className} = props;
    if (!user) {
        return null;
    }

    const isOnline = user?.is_online === true;
    const userName = getUserName(user, true);

    return <Wrapper
            className={classnames('inline-user-representation', className)}
            style={props.avatarSize ? {
                '--inline-user-representation--size': `${props.avatarSize}px`,
            } as React.CSSProperties : undefined}
    >
        <span className={classnames([
            'inline-user-representation__avatar-wrapper',
            props.avatarWrapperClassName,
        ])}>
            <img
                    src={user.avatar_public_path ?? avatarPlaceholder}
                    alt={userName}
                    className={classnames('inline-user-representation__avatar', {
                        'inline-user-representation__avatar--online': isOnline,
                    })}
                    title={isOnline ? 'Online' : 'Offline'}
            />
        </span>
        <span className="inline-user-representation__name" title={title ?? userName}>
            {userName}
        </span>
        {props.children}
    </Wrapper>;
}
